module.exports = __webpack_public_path__ + "img/tree04.8b59ffec.png";